import * as types from './types';
import { fetchGeneric } from 'State/generic/actions';

export const getFiscalYearsAction = () =>
  fetchGeneric(
    types.GET_FISCAL_YEARS,
    types.GET_FISCAL_YEARS_LOADING,
    types.GET_FISCAL_YEARS_ERROR,
    'ControlInfo/FiscalYears'
  );



// WEBPACK FOOTER //
// ./src/state/fiscalYears/actions.js